import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.MedidaDesarrollo &&
    (path = `${path !== '' ? `${path}&` : ''}MedidaDesarrollo=${params.MedidaDesarrollo}`);

  return path;
};
